import styled from 'styled-components';

export const Root = styled.div`
  dislplay: flex;
  margin-left: 70px;
  margin-right: 70px;
`;

export const Title = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
`

export const BoxEmpty = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Box = styled.div`
  width: 100%;
  min-height: 547px;
  height: calc(100vh - 480px);
  margin-top: 15px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  overflow-y: scroll;
`

export const FileHeader = styled.div`
  width: 100%;
  display: flex;
  height: 50px;
  align-items: center;
  border-bottom: 1px solid #dddddd;
`

export const FileNameLabel = styled.div`
  width: calc(100% - 58px);
  margin: 0 29px 0px 29px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #204078;
`

export const FileUploadLabel = styled.div`
  width: 51px;
  flex-grow: 0;
  margin: 0 0 0px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #204078;
`

export const FileTagLabel = styled.div`
  width: 35px;
  margin: 0 93px 0px 70px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #204078;
`

export const Text = styled.span`
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: rgba(112, 112, 112, 0.5);
    margin-top: 44px;
`